import React from "react"

const PageNotFound = () => {
    return (
        <div style={container}>
            <h1>Pagina no encontrada</h1>
        </div>
    )
}
export default PageNotFound;

const container: any={
    textAlign: "center"
}